import { createSlice } from '@reduxjs/toolkit';
import {
  getSiteConfiguration,
  saveSiteConfiguration,
} from './configurationAction';

const siteConfigurationSlice = createSlice({
  name: 'siteConfigurationSlice',
  initialState: {
    loading: false,
    error: null,
    data: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    // Get
    builder.addCase(getSiteConfiguration.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getSiteConfiguration.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.data = payload.data;
    });
    builder.addCase(getSiteConfiguration.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    // Create / Update
    builder.addCase(saveSiteConfiguration.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(saveSiteConfiguration.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.data = payload.data;
    });
    builder.addCase(saveSiteConfiguration.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export { siteConfigurationSlice };
